import { render, staticRenderFns } from "./GroupInput.vue?vue&type=template&id=2fa79f0c&scoped=true"
import script from "./GroupInput.vue?vue&type=script&lang=js"
export * from "./GroupInput.vue?vue&type=script&lang=js"
import style0 from "./GroupInput.vue?vue&type=style&index=0&id=2fa79f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa79f0c",
  null
  
)

export default component.exports